import React, { createContext, useState } from 'react';

export const BingoUserDataContext = createContext();

export const BingoUserDataProvider = ({ children }) => {
  const [user, setUser] = useState({
    name: '',
    email: '',
    playerId: '',
    card: [],
    pin: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  return (
    <BingoUserDataContext.Provider value={{ user, setUser, isLoading, setIsLoading }}>
      {children}
    </BingoUserDataContext.Provider>
  );
};